import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, CardContent, CardHeader, Divider, Grid, Tooltip } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { EstadoCivilValues } from '../../../../values/EstadoCivilValues';
import moment from 'moment';
import Badge from '@material-ui/core/Badge';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import withStyles from '@material-ui/core/styles/withStyles';
import DialogConfirmacao from '../../../../components/DialogConfirmacao/DialogConfirmacao';
import DialogContentText from '@material-ui/core/DialogContentText';


function FiliadoRegisterInfo(props) {
  const {
    filiado,
    setFiliado,
    filiacaoStatus,
    gruposSanguineos,
    edicao,
    aoModificarImagemFiliado,
    deletarImagem
  } = props;
  const [nome, setNome] = useState(props.filiado.nome);
  const [cpf, setCpf] = useState(props.filiado.cpf);
  const [rg, setRg] = useState(props.filiado.rg);
  const [orgaoExpedidor, setOrgaoExpedidor] = useState(props.filiado.orgaoExpedidor);
  const [dataExpedicao, setDataExpedicao] = useState(props.filiado.dataExpedicao);
  const [dataValidadeAnuidade, setDataValidadeAnuidade] = useState(props.filiado.validadeAnuidade);
  const [dataNascimento, setDataNascimento] = useState( props.filiado.dataNascimento ? moment(props.filiado.dataNascimento).format('YYYY-MM-DD 00:00:00') : undefined);
  const [profissao, setProfissao] = useState(props.filiado.profissao);
  const [estadoCivil, setEstadoCivil] = useState(props.filiado.estadoCivil);
  const [nomePai, setNomePai] = useState(props.filiado.nomePai);
  const [nomeMae, setNomeMae] = useState(props.filiado.nomeMae);
  const [email, setEmail] = useState(props.filiado.email);
  const [numeroCr, setCr] = useState(props.filiado.numeroCr);
  const [validadeCr, setValidadeCr] = useState(props.filiado.validadeCr);
  const [idFiliacaoStatus, setIdFiliacaoStatus] = useState(props.filiado.idFiliacaoStatus);
  const [idGrupoSanguineo, setIdGrupoSanguineo] = useState(props.filiado.idGrupoSanguineo);
  const [codigo, setCodigo] = useState(props.filiado.codigo);
  const [maskCpf] = useState('999.999.999-99');
  const [senha, setSenha] = useState(props.filiado.senha);
  const [replicaSenha, setReplicaSenha] = useState('');
  const [abrirDialogConfirmacaoApagarImagemPerfil, setAbrirDialogConfirmacaoApagarImagemPerfil] = useState(false);
  const [refreshState, setRefreshState] = useState(new Date());



  useEffect(() => {
    async function validatorSenha() {
      ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        return value == senha;
      });
    }
    validatorSenha()
  }, [replicaSenha]);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  const handleChangeDatNascimento = date => {
    filiado.dataNascimento = moment(date).format("YYYY-MM-DD 00:00:00");
    setFiliado(filiado);
    setDataNascimento(date);
  };

  const handleChangeDataExpedicao = date => {
    filiado.dataExpedicao = date;
    setFiliado(filiado);
    setDataExpedicao(date);
  };

  const handleChangeDataValidadeAnuidade = date => {
    filiado.validadeAnuidade = date;
    setFiliado(filiado);
    setDataValidadeAnuidade(date);
  };

  const handleChangeValidadeCr = date => {
    filiado.validadeCr = date;
    setFiliado(filiado);
    setValidadeCr(date);
  };

  function modificarValores(order, value){
    switch (order) {
      case 0:
        filiado.nome = value;
        setFiliado(filiado);
        setNome(value);
        break;
      case 1:
        filiado.cpf = value;
        setFiliado(filiado);
        setCpf(value);
        break;
      case 2:
        filiado.rg = value;
        setFiliado(filiado);
        setRg(value);
        break;
      case 3:
        filiado.orgaoExpedidor = value;
        setFiliado(filiado);
        setOrgaoExpedidor(value);
        break;
      case 4:
        filiado.profissao = value;
        setFiliado(filiado);
        setProfissao(value);
        break;
      case 5:
        filiado.estadoCivil = value;
        setFiliado(filiado);
        setEstadoCivil(value);
        break;
      case 6:
        filiado.nomePai = value;
        setFiliado(filiado);
        setNomePai(value);
        break;
      case 7:
        filiado.nomeMae = value;
        setFiliado(filiado);
        setNomeMae(value);
        break;
      case 8:
        filiado.email = value;
        setFiliado(filiado);
        setEmail(value);
        break;
      case 9:
        filiado.numeroCr = value;
        setFiliado(filiado);
        setCr(value);
        break;
        break;
      case 10:
        filiado.idFiliacaoStatus = value;
        setFiliado(filiado);
        setIdFiliacaoStatus(value);
        break;
      case 11:
        filiado.idGrupoSanguineo = value;
        setFiliado(filiado);
        setIdGrupoSanguineo(value);
        break;
      case 12:
        if (!value) {
          filiado.codigo = null;
        }
        else {
          filiado.codigo = value;
        }
        setFiliado(filiado);
        setCodigo(value);
        break;
      case 13:
        filiado.naturalidade = value;
        setFiliado(filiado);
        break;
    }
    setRefreshState(new Date());
  }

  const SmallAvatar = withStyles((theme) => ({
    root: {
      width: 32,
      height: 32,
      border: `2px solid ${theme.palette.background.paper}`,
      backgroundColor: theme.palette.error.main
    },
  }))(Avatar);

  function confirmarDeleteImagem(e) {
    setAbrirDialogConfirmacaoApagarImagemPerfil(false);
    deletarImagem(e)
  }

  return (
    <div>
      <CardHeader
        subheader="Informe as seguintes campos do filiado"
        title={edicao ? "Edicao de filiado" : "Cadastro de Filiado"}
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={12}
            xs={12}
          >
            <DialogConfirmacao
              mensagemBotaoEsquerda={'CANCELAR'}
              mensagemBotaoDireita='REMOVER'
              acaoBotaoEsquerda={() => {setAbrirDialogConfirmacaoApagarImagemPerfil(false)}}
              acaoBotaoDireita={e => confirmarDeleteImagem(e)}
              componenteExtraDialogContent={
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <DialogContentText id={'mensagemPrincipalDialog'}>
                      {`Tem certeza que deseja remover a imagem desse filiado?`}
                    </DialogContentText>
                  </Grid>
                </Grid>
              }
              tituloDialog={'Confirmação'}
              open={abrirDialogConfirmacaoApagarImagemPerfil}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Tooltip
              title={'Clique para editar a foto do seu perfil'}
              placement={'top'}
            >
              <Badge
                overlap="circle"
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                invisible={!filiado.imagem || !filiado.imagem.url}
                badgeContent={
                  <SmallAvatar
                    alt="Remover imagem"
                    onClick={e => setAbrirDialogConfirmacaoApagarImagemPerfil(true)}
                    style={{
                      cursor: 'pointer'
                    }}
                  >
                    <DeleteOutlineIcon style={{fontSize: 16}}/>
                  </SmallAvatar>
                }

              >
                <input
                  accept=".png, .jpg, .jpeg"
                  id="contained-button-file"
                  multiple={false}
                  type="file"
                  onChange={e => aoModificarImagemFiliado(e)}
                  style={{
                    display: 'none'
                  }}
                />
                <label htmlFor="contained-button-file">
                  <Avatar
                    style={{
                      width: 136,
                      height: 136,
                      cursor: "pointer"
                    }}
                    alt="Imagem do filiado"
                    src={filiado && filiado.imagem && filiado.imagem.url}
                  >
                  </Avatar>
                </label>

              </Badge>
            </Tooltip>
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <TextValidator
                  fullWidth
                  label="Código"
                  helperText="Código para identificação do usuário"
                  type='number'
                  margin="dense"
                  name="nome_filiado"
                  onChange={e => modificarValores(12, e.target.value)}
                  value={codigo}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
              >
                <TextValidator
                  fullWidth
                  label="Nome completo"
                  helperText="Insira o nome completo."
                  margin="dense"
                  name="nome_filiado"
                  onChange={e => modificarValores(0, e.target.value)}
                  value={nome}
                  variant="outlined"
                  validators={['required', 'minStringLength:3', 'maxStringLength:155']}
                  errorMessages={['Insira o nome completo.', 'Nome muito curto.', 'Nome muito longo.']}
                />
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
              >
                <SelectValidator
                  fullWidth
                  helperText="Insira o status do filiado."
                  label="Status"
                  margin="dense"
                  name="status_filiado"
                  onChange={e => modificarValores(10, e.target.value)}
                  value={idFiliacaoStatus}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Insira o status do filiado.']}
                >
                  {filiacaoStatus.result.map((status, index) => (
                    <MenuItem key={index} value={status.idFiliacaoStatus}>{status.descricao}</MenuItem>
                  ))}

                </SelectValidator>

              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >

            <InputMask
              mask={maskCpf}
              value={cpf}
              onChange={e => modificarValores(1, e.target.value)}
            >
              {
                (inputProps) =>
                  <TextValidator
                    fullWidth
                    label="CPF"
                    margin="dense"
                    name="cnpj"
                    onChange={inputProps.onChange}
                    type="text"
                    variant="outlined"
                    helperText="Insira o CPF."
                  />

              }
            </InputMask>
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="RG"
              helperText="Insira o RG."
              margin="dense"
              name="rg"
              onChange={e => modificarValores(2, e.target.value)}
              value={rg}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Orgão Expeditor"
              helperText="Insira o Orgão Expeditor."
              margin="dense"
              name="rg"
              onChange={e => modificarValores(3, e.target.value)}
              value={orgaoExpedidor}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  orientation="landscape"
                  id="dataExpedicao"
                  label="Data de Expedição"
                  helperText={'Insira a data de expedição do RG'}
                  format="dd/MM/yyyy"
                  size='small'
                  value={dataExpedicao}
                  onChange={handleChangeDataExpedicao}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Naturalidade"
              helperText="Insira a naturalidade."
              margin="dense"
              name="naturalidade"
              onChange={e => modificarValores(13, e.target.value)}
              value={filiado.naturalidade}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <SelectValidator
              fullWidth
              helperText="Insira o tipo sanguíneo do filiado."
              label="Grupo Sanguíneo"
              margin="dense"
              name="tipo_sanguineo"
              onChange={e => modificarValores(11, e.target.value)}
              value={idGrupoSanguineo}
              variant="outlined"
            >
              {gruposSanguineos.result.map((tipo, index) => (
                <MenuItem key={index} value={tipo.idGrupoSanguineo}>{tipo.descricao}</MenuItem>
              ))}
            </SelectValidator>
          </Grid>
          <Grid
            item
            lg={4}
            md={4}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  orientation="landscape"
                  id="validadeAnuidade"
                  label="Data de validade da anuidade"
                  helperText={'Insira a data de validade da anuidade'}
                  format="dd/MM/yyyy"
                  size='small'
                  value={dataValidadeAnuidade}
                  onChange={handleChangeDataValidadeAnuidade}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            lg={3}
            md={3}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  orientation="landscape"
                  id="dataNascimento"
                  label="Data de Nascimento"
                  helperText={'Insira a data de nascimento'}
                  format="dd/MM/yyyy"
                  size='small'
                  value={dataNascimento}
                  onChange={handleChangeDatNascimento}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Profissão"
              helperText="Insira a profissão do filiado."
              margin="dense"
              name="profissao"
              onChange={e => modificarValores(4, e.target.value)}
              value={profissao}
              variant="outlined"
              validators={['maxStringLength:100']}
              errorMessages={['Profissão muito longa.']}
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <SelectValidator
              fullWidth
              helperText="Insira o estado civil."
              label="Estado civil"
              margin="dense"
              name="estadoCivil"
              onChange={e => modificarValores(5, e.target.value)}
              value={estadoCivil}
              variant="outlined"
            >
              {EstadoCivilValues.map((estado, index) => (
                <MenuItem key={index} value={estado.value}>{estado.label}</MenuItem>
              ))}

            </SelectValidator>

          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Nome do pai"
              helperText="Insira o nome do pai do filiado."
              margin="dense"
              name="nomePai"
              onChange={e => modificarValores(6, e.target.value)}
              value={nomePai}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Nome da mãe"
              helperText="Insira o nome da mãe do filiado."
              margin="dense"
              name="nomeMae"
              onChange={e => modificarValores(7, e.target.value)}
              value={nomeMae}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Email"
              helperText="Insira o email."
              margin="dense"
              name="email"
              onChange={e => modificarValores(8, e.target.value)}
              value={email}
              variant="outlined"
              validators={['isEmail']}
              errorMessages={['Informe um email válido.']}
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="CR"
              helperText="Insira o número da Certificação de Registro do filiado."
              margin="dense"
              name="email"
              onChange={e => modificarValores(9, e.target.value)}
              value={numeroCr}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            lg={3}
            md={3}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  orientation="landscape"
                  helperText={'Insira a data de validade da Certificação de Registro do filiado'}
                  id="validadeCr"
                  label="Validade CR"
                  format="dd/MM/yyyy"
                  size='small'
                  value={validadeCr}
                  onChange={handleChangeValidadeCr}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />

    </div>
  );
};

FiliadoRegisterInfo.propTypes = {
  className: PropTypes.string,
  filiado: PropTypes.object.isRequired,
  setFiliado: PropTypes.object.isRequired
};

export default FiliadoRegisterInfo;


